import type { Landmark, PaletteModel } from '../../../data/types';
import type { WaterCover } from '../../../render/waterCover';
import { damPassages } from './dam';

/** The water under each dam's vault, which the vault's stone shades (render/waterCover.ts). */
export function damWaterCovers(
  landmarks: readonly Landmark[],
  palette: PaletteModel
): readonly WaterCover[] {
  return landmarks
    .filter((landmark) => landmark.kind === 'dam')
    .flatMap((landmark) =>
      damPassages(landmark).map((passage) => ({
        from: passage.from,
        to: passage.to,
        halfWidthM: passage.halfSpanM,
        roof: palette.towerStone.median.linear,
      }))
    );
}
